import { useState } from "react";
import { TOOLS } from "@/data/site";

export const Toolkit = () => {
  const [active, setActive] = useState(null);

  return (
    <section
      data-testid="toolkit"
      className="relative border-t border-[#1f1f1f] py-12 md:py-16"
    >
      <div className="mx-auto max-w-[1700px] px-5 md:px-10">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <span className="label shrink-0 text-[#7a7a7a]">
            THE TOOLKIT BEHIND THE WORK
          </span>
          <div className="flex flex-wrap items-center gap-2">
            {TOOLS.map((t, i) => (
              <button
                key={t.name}
                type="button"
                onMouseEnter={() => setActive(i)}
                onMouseLeave={() => setActive(null)}
                onFocus={() => setActive(i)}
                onClick={() => setActive(i)}
                data-testid={`tool-${t.name.toLowerCase().replace(/ /g, "-")}`}
                data-cursor="view"
                className="border px-4 py-3 label transition-all duration-300"
                style={{
                  borderColor: active === i ? "#d4ff00" : "#262626",
                  color: active === i ? "#d4ff00" : "#a3a3a3",
                }}
              >
                {t.name}
              </button>
            ))}
          </div>
        </div>
        <p
          className="mt-6 h-5 text-sm text-[#e5e5e5] transition-opacity duration-300"
          data-testid="toolkit-detail"
          style={{ opacity: active === null ? 0.45 : 1 }}
        >
          {active === null
            ? "Hover a tool to see what it's actually used for."
            : TOOLS[active].use}
        </p>
      </div>
    </section>
  );
};
